import { render } from "./editlocation.vue?vue&type=template&id=2171dd06"
import script from "./editlocation.vue?vue&type=script&lang=js"
export * from "./editlocation.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/backoffice_jempolku_hijau/backoffice_jempolku_hijau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__